import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;
export const roleService = { getAll, store, show, update, patch, updateStatus, softDelete };
export function getAll(filter = {}) {
    const params = { page: filter.pageNumber, size: filter.pageSize };
    if (filter.searchArray?.length) params.search_words = filter.searchArray;
    return apiHelper(API_URL).get('/roles', { params });
}
function payload(data) {
    return { ...data.permissions, name: data.name, description: data.description, is_active: Boolean(data.isActive) };
}
export function store(data) { return apiHelper(API_URL).post('/roles', payload(data)); }
export function show(uuid) { return apiHelper(API_URL).get(`/roles/${uuid}`); }
export function update(data) { return apiHelper(API_URL).put(`/roles/${data.uuid}`, payload(data)); }
export function patch(uuid, data) { return apiHelper(API_URL).patch(`/roles/${uuid}`, data); }
export function updateStatus(uuid, isActive) { return apiHelper(API_URL).patch(`/roles/${uuid}/status`, { is_active: Boolean(isActive) }); }
export function softDelete(uuid) { return apiHelper(API_URL).patch(`/roles/delete/${uuid}`); }
